module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Italic.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Italic.eot
// module id = 1896
// module chunks = 0